import { useLayoutEffect, useState } from "react";

import { isSuperAdminUrl } from "@src/utility/helpers/utils";
import useAxios from "@hooks/use-axios";
import { useLocation } from "react-router-dom";

const useProducts = () => {
    const [products, setProducts] = useState([]);
    const { axiosInstance, loading, cancelAllRequests } = useAxios({ base: "panel" });
    const location = useLocation();

    const getProducts = async () => {
        const response = await axiosInstance.get("/platform");
        setProducts(response?.data || []);
    };

    useLayoutEffect(() => {
        let isActive = true;
        if (isActive && !isSuperAdminUrl()) {
            getProducts();
        }

        return () => {
            isActive = false;
            cancelAllRequests();
        };
    }, [location.pathname]);

    return {
        products,
        loading,
        getProducts
    };
    
};

export default useProducts;
